import {GET_OmrCodes} from '../constants/ActionTypes'

const INIT_STATE = {
    OmrCodes: null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_OmrCodes:
            return {
                OmrCodes: action.body,
                loading :false
            }
        default:
            return state;
    }
}